export default {
  CURRENCYSYMBOL: '￥',
  MAXNINEDIGITNUM: 999999999,
  ATTACHEMENT_MAX_SIZE: 1024 * 1024 * 50, // 附件上传max size
  PICTURE_MAX_SIZE: 1024 * 1024 * 10, // 图片上传max size
  ATTACHEMENT_MAX_COUNT: 10, // 附件最大上传数量
  CUSTOMER_ATTACHEMENT_MAX_COUNT: 50, // 某些客户指定附件最大上传数量
  IMAGE_MAX_COUNT: 9, // 图片最大上传数量
  MAXSKUNUM: 600, // 最大物料单品数量
  MTCOUNTDECIMAL: 4, // 物料小数位
  MAXDATETIMESTAMP: 4102358400000, // 最大时间戳：2100-01-01
};
